import { Link } from "react-router-dom";
import { useState } from "react";

const HeaderNavs = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="bg-black/50 backdrop-blur-sm fixed w-full z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="/logo/footer_logo.svg" 
                alt="Rumble Logo" 
                className="h-12 w-auto sm:h-14"
              />
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-primary-100 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center justify-center space-x-8">
            <Link to="/" className="text-white hover:text-primary-100 transition-colors code-mono">
              Home
            </Link>
            <a 
              href="#characters" 
              onClick={(e) => scrollToSection(e, 'characters')}
              className="text-white hover:text-primary-100 transition-colors cursor-pointer code-mono"
            >
              Characters
            </a>
            <a 
              href="#roadmap" 
              onClick={(e) => scrollToSection(e, 'roadmap')}
              className="text-white hover:text-primary-100 transition-colors cursor-pointer code-mono"
            >
              Roadmap
            </a>
            <a 
              href="#team" 
              onClick={(e) => scrollToSection(e, 'team')}
              className="text-white hover:text-primary-100 transition-colors cursor-pointer code-mono"
            >
              Team
            </a>
            <div className="flex items-center space-x-4">
              <a
                href="https://twitter.com/RumbleGame"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-primary-100 transition-colors"
              >
                <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a
                href="https://discord.gg/rumble"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-primary-100 transition-colors"
              >
                <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                </svg>
              </a>
            </div>
            <Link 
              to="/arena" 
              className="text-white hover:text-primary-100 transition-colors bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg code-mono"
            >
              Play Arena
            </Link>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden`}>
          <div className="px-2 pt-2 pb-3 space-y-1 bg-black/90 rounded-b-lg">
            <Link 
              to="/" 
              className="block px-3 py-2 text-white hover:text-primary-100 transition-colors code-mono"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <a 
              href="#characters" 
              onClick={(e) => scrollToSection(e, 'characters')}
              className="block px-3 py-2 text-white hover:text-primary-100 transition-colors cursor-pointer code-mono"
            >
              Characters
            </a>
            <a 
              href="#roadmap" 
              onClick={(e) => scrollToSection(e, 'roadmap')}
              className="block px-3 py-2 text-white hover:text-primary-100 transition-colors cursor-pointer code-mono"
            >
              Roadmap
            </a>
            <a 
              href="#team" 
              onClick={(e) => scrollToSection(e, 'team')}
              className="block px-3 py-2 text-white hover:text-primary-100 transition-colors cursor-pointer code-mono"
            >
              Team
            </a>
            <Link 
              to="/arena" 
              className="block px-3 py-2 text-white hover:text-primary-100 transition-colors bg-orange-500 hover:bg-orange-600 rounded-lg mt-2 code-mono"
              onClick={() => setIsMenuOpen(false)}
            >
              Play Arena
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderNavs;
